// THIS IS RUN IN JS AS...

/*

typescript pops a fuss surrounding the use of this.renderChart

\/\/\/\/ this is actually the way the documentation recommends importing graphs using vue-graphjs

*/

import { Line } from 'vue-chartjs';

Chart.plugins.register({
    beforeDraw: function(chart) {
       var ctx = chart.chart.ctx,
          x_axis = chart.scales['x-axis-0'],
          topY = chart.scales['y-axis-0'].top,
          bottomY = chart.scales['y-axis-0'].bottom;
       x_axis.options.gridLines.display = false;
       x_axis.ticks.forEach(function(label, index) {
          var x = x_axis.getPixelForValue(label);
          ctx.save();
          ctx.beginPath();
          ctx.moveTo(x, topY);
          ctx.lineTo(x, bottomY);
          ctx.lineWidth = 1;
          ctx.strokeStyle = x_axis.options.gridLines.color;
          ctx.stroke();
          ctx.restore();
       });
    }
 });

export default{
    name: "LineGraph",
    extends: Line,
    props: ['white'],
    data () {
        return {
        datacollection: {
        //Data to be represented on x-axis
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], 
            datasets: [
            {
                label: 'Data One',
                backgroundColor: this.white?'#FFFFFF':'#3674ff',
                borderWidth: 2,
                borderColor: this.white?'#FFFFFF':'#3674ff',
                pointBackgroundColor: this.white?'#FFFFFF':'#5cd9ff',
                pointRadius: 4,
                pointHoverRadius: 6,
                pointBorderWidth: 2,
                pointBorderColor:this.white?'#3674ff':'#FFFFFF',
                pointHoverBorderColor: this.white?'#5cd9ff':'#FFFFFF',
                fill: false,
                spanGaps: true,
                //Data to be represented on y-axis
                data: [40, 20, 30, 50, 90, 10, NaN, 40, 50, 70, 90, 100]
            }
            ]
        },
        //Chart.js options that controls the appearance of the chart
        options: {
            title: {
                display: false,
                text: 'Hours worked / Day',
                fontFamily: "'Nunito', sans-serif",
                fontColor: this.white?'#FFFFFF':'#3674ff',
                padding: 5,
                fontSize: 10,
                position: 'top',
            },
            scales: {
                
                yAxes: [{
                    ticks: {
                        fontColor: this.white?'rgba(255,255,255,0.1)':'#a1a1a1',
                        padding: 20,
                    },
                    display: true,
                    gridLines: {
                        drawBorder: true,
                        color: this.white?'rgba(255,255,255,0.1)':'rgb(245, 246, 249)',
                    }
                }],
                xAxes: [{
                    ticks: {
                        fontColor: this.white?'rgba(255,255,255,0.1)':'rgba(0,0,0,0.5)',
                        fontSize: 11,
                        padding: 10,
                    },
                    display: true,
                    gridLines: {
                        display: false,
                        drawBorder: false,
                        color: this.white?'rgba(255,255,255,0.1)':'rgba(0,0,0,0.01)'
                    }
                }]
            },
            legend: {
                display: false 
            },
            responsive: true,
            maintainAspectRatio: false
        }
        }
    },
    mounted () {
    //renderChart function renders the chart with the datacollection and options object.
        this.renderChart(this.datacollection, this.options)
    }
}